<template lang="pug">
div(class="banner-image relative h-0 mx-auto overflow-hidden" :class="{ 'is-home': size === 'HOME', 'is-blog': size === 'BLOG' }")
    div(class="absolute top-0 left-0 w-full h-full")
        flexLink(
            v-if="banner.url"
            :to="getRefittedUrl(banner.url)"
            aria-label="ad"
        )
            img(:src="imageUrl" :width="getWidth" :height="getHeight" class="mx-auto" :loading="isLazy ? 'lazy' : 'eager'" alt="")
        img(v-else :src="imageUrl" :width="getWidth" :height="getHeight" class="mx-auto" :loading="isLazy ? 'lazy' : 'eager'" alt="")
</template>

<script>
import getRefittedUrlMixin from '@/helpers/getRefittedUrlMixin'
import flexLink from '@/components/flexLink'
export default {
    components: {
        flexLink,
    },
    mixins: [getRefittedUrlMixin],
    props: {
        banner: {
            type: Object,
            required: true,
        },
        size: {
            type: String,
            default: '',
        },
        isLazy: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        /*
            Desktop: 1344x300 (cat/brand), 1920x450 (homepage), 960x214 (blog)
            Mobile: 768x465
        */
        getWidth() {
            if (this.$device.isMobile) return this.size === 'BLOG' ? 767 : 768
            if (this.size === 'HOME' || this.size === 'BLOG') return 1920
            return 1344
        },
        getHeight() {
            if (this.$device.isMobile) return this.size === 'BLOG' ? 300 : 465
            if (this.size === 'HOME') return 450
            if (this.size === 'BLOG') return 305
            return 300
        },
        imageUrl() {
            const width = this.getWidth
            const height = this.getHeight
            const quality = this.$device.isMobile ? 70 : 85
            return this.$getImageUrl(
                this.banner.image.key,
                this.banner.image.filename,
                width,
                height,
                quality
            )
        },
    },
}
</script>

<style lang="stylus" scoped>
.banner-image
    padding-bottom 60%
    &.is-blog
        padding-bottom 40%
@screen md
    .banner-image
        padding-bottom 22.5%
        &.is-home
            padding-bottom 23.6%
        &.is-blog
            padding-bottom 16%
</style>
